import avax from '@assets/tokens/AVAX.png';
import bnb from '@assets/tokens/BNB.png';
import emp from '@assets/tokens/EMP.png';
import eshare from '@assets/tokens/ESHARE.png';
import eth from '@assets/tokens/ETH.png';
import ftm from '@assets/tokens/FTM.png';
import pulse from '@assets/tokens/PULSE.png';
import usdc from '@assets/tokens/USDC.png';
import usdexPlus from '@assets/tokens/USDEX+.png';
import vaultInvestment from '@assets/tokens/VAULT_INVESTMENTS.png';
import dDex from '@assets/tokens/gDEX.png';
import unknownLogo from '@assets/tokens/unknownLogo.svg?url';

import { STORAGE_ICONS } from '@constants/common/api.constants';
import { TokenSymbol } from '@constants/common/tokens.constants';

export const getTokenForSymbol = (symbol: string): string => {
  const logosBySymbol: { [title: string]: string } = {
    [TokenSymbol.EMP]: emp,
    [TokenSymbol.BNB]: bnb,
    [TokenSymbol.ESHARE]: eshare,
    [TokenSymbol.WBNB]: bnb,
    [TokenSymbol.AVAX]: avax,
    [TokenSymbol.ETH]: eth,
    [TokenSymbol.FTM]: ftm,
    [TokenSymbol.PLS]: pulse,
    [TokenSymbol.VAULT_INVESTMENTS]: vaultInvestment,
    [TokenSymbol.GDEX]: dDex,
    [TokenSymbol.USDEX_PLUS]: usdexPlus,
    [TokenSymbol.USDC]: usdc,
  };

  if (
    Object.keys(logosBySymbol).includes(symbol?.toUpperCase()) ||
    Object.keys(logosBySymbol).includes(symbol)
  ) {
    return logosBySymbol[symbol.toUpperCase()] || logosBySymbol[symbol];
  }
  return unknownLogo;
};

export const getTokenIconUrl = ({
  chainId,
  address,
}: {
  chainId: number;
  address: string;
}): string => {
  if (!chainId || !address) {
    return unknownLogo;
  }

  return `${STORAGE_ICONS}/${chainId}/${address.toLowerCase()}` || '';
};

export const getDexScreenerChainIcon = (dexscreenerChainId: string) =>
  `https://dd.dexscreener.com/ds-data/chains/${dexscreenerChainId}.png`;

export const getDexScreenerDexIcon = (dexName: string) =>
  `https://dd.dexscreener.com/ds-data/dexes/${dexName}.png`;

export const getDexScreenerFarmIcon = (
  dexscreenerChainId: string,
  address: string,
) =>
  `https://dd.dexscreener.com/ds-data/tokens/${dexscreenerChainId}/${address}.png` ||
  'https://dexfi.com/icons/unknownLogo.png';
